<template>
  <div class="card shadow-sm p-3">
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th
              v-for="(col, index) in visibleColumns"
              :key="index"
              class="table-header"
            >
              <div class="d-flex justify-content-between align-items-center">
                <span
                  v-if="col.filterable !== false"
                  @click.stop="$emit('sort', col.key)"
                  style="cursor: pointer"
                >
                  {{ col.label }}
                  <span v-if="sort.key === col.key">
                    <i
                      :class="
                        sort.order === 'desc'
                          ? 'bi bi-arrow-down'
                          : 'bi bi-arrow-up'
                      "
                    ></i>
                  </span>
                </span>
                <span v-else>
                  {{ col.label }}
                </span>

                <div class="position-relative ms-2">
                  <button
                    class="btn btn-sm btn-light border-0"
                    @click.stop="toggleDropdown(col.key)"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>

                  <div
                    v-if="openDropdownKey === col.key"
                    class="dropdown-menu show p-2"
                    style="
                      position: absolute;
                      right: 0;
                      top: 100%;
                      z-index: 999;
                    "
                  >
                    <h6 class="dropdown-header">Toggle Columns</h6>
                    <div
                      v-for="(c, i) in localColumns"
                      :key="c.key"
                      class="form-check"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'toggle-col-' + col.key + '-' + i"
                        v-model="localColumns[i].visible"
                      />
                      <label
                        class="form-check-label"
                        :for="'toggle-col-' + col.key + '-' + i"
                      >
                        {{ c.label }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="isLoading">
            <tr v-for="n in 5" :key="'skeleton-' + n">
              <td :colspan="visibleColumns.length">
                <div class="skeleton-loader w-100" style="height: 20px"></div>
              </td>
            </tr>
          </template>

          <tr v-else-if="rows.length === 0">
            <td :colspan="visibleColumns.length" class="text-center py-5">
              No data available
            </td>
          </tr>

          <template v-else>
            <tr v-for="(row, idx) in rows" :key="idx">
              <td v-for="(col, index) in visibleColumns" :key="index">
                {{ row[col.key] }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataTable",
  props: {
    rows: Array,
    columns: Array,
    sort: Object,
    isLoading: Boolean,
  },
  data() {
    return {
      localColumns: [],
      openDropdownKey: null,
    };
  },
  computed: {
    visibleColumns() {
      return this.localColumns.filter((col) => col.visible);
    },
  },
  watch: {
    columns: {
      immediate: true,
      deep: true,
      handler(newColumns) {
        this.localColumns = newColumns.map((col) => ({ ...col }));
      },
    },
  },
  methods: {
    toggleDropdown(key) {
      this.openDropdownKey = this.openDropdownKey === key ? null : key;
    },
  },
};
</script>
  
<style scoped>
.skeleton-loader {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: shimmer 1.2s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.table-header {
  vertical-align: middle;
  min-width: 180px;
}

@media (max-width: 768px) {
  .table-header {
    min-width: 100px;
    font-size: 0.8rem;
  }

  th,
  td {
    font-size: 0.75rem;
    padding: 0.3rem 0.4rem;
  }
}
</style>
  